<template>
  <b-container>
    <b-card no-body>
      <template v-slot:header>
        <b-button size="sm" variant="primary float-right" :to="{name: `${collection}_create`}">Create</b-button>
      </template>

      <b-table hover :items="items" :fields="fields" @row-clicked="view_row" tbody-tr-class="hover_row" show-empty>
      </b-table>
    </b-card>
  </b-container>
</template>

<script>

import { db } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'

export default {
  name: 'locations',
  mixins: [ItemMixin],
  firestore: function () {
    return {
      items: db.collection('site').doc(this.$route.params.site_id).collection(this.collection).orderBy('created', 'desc')
    }
  },
  data() {
    return {
      items: [],
      collection: 'location',
      fields: [
        {key: 'name'},
        {key: 'address_line_1'},
        {key: 'city'}
      ]
    }
  },
  methods: {
    view_row(item) {
      this.$router.push({name: this.collection, params: {id: item.id}})
    }
  },
  metaInfo() {
    return {
      title: `${this.collection}s`
    };
  },
}
</script>

<style>

.hover_row {
  cursor: pointer !important;
}

</style>
